import React from "react";
import { Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import "./custom.css";
import "./fonts/Inter-VariableFont_slnt,wght.ttf";
import Login from "./components/Login";
import Portfolio from "./components/Portfolio";
import Error from "./components/Error";
import {
  AuthenticatedTemplate,
} from "@azure/msal-react";
import { useAuthProvider } from "./auth/hooks/AuthProvider";

export default function App() {
  const { user } = useAuthProvider();

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/portfolio"
          element={
            <AuthenticatedTemplate>
              {user ? <Portfolio /> : ""}
            </AuthenticatedTemplate>
          }
        />
        <Route path="/*" element={<Error />} />
      </Routes>
    </Layout>
  );
}
